<template>
  <div>
    <v-container style="height: 300px;" v-if="loading">
      <v-row class="fill-height" align-content="center" justify="center">
        <v-col cols="6">
          <v-progress-linear color="deep-purple accent-4" indeterminate rounded height="6"></v-progress-linear>
        </v-col>
      </v-row>
    </v-container>
    <template v-else>
      <v-card v-if="docuSignObj">
        <v-card-text>
          <v-row class="pb-0">
            <v-col class="py-0 d-flex" cols="12">
              <p> <span class="font-weight-black">{{ $t('message.customer.name')}}: </span> {{ docuSignObj.name }}</p>
              <v-btn class="mx-2" small color="primary" @click="$format.openLinkInNewTab(docuSignObj.downloadurl)" outlined>
                <v-icon class="mr-2">mdi-cloud-download</v-icon>
                {{ $t('message.order.download') }}
              </v-btn>
            </v-col>
            <v-col class="py-0" cols="6">
              <p> <span class="font-weight-black">{{$t('message.documents.validityTime')}}: </span> {{ docuSignObj.invitations_valid_until }}</p>
            </v-col>
            <v-col class="py-0" cols="6">
              <p><span class="font-weight-black">{{ $t('message.common.status') }}: </span> {{ docuSignObj.status }}</p>
            </v-col>
            <v-col class="py-0" cols="6">
              <p> <span class="font-weight-black">{{$t('message.unimicro.createdOn')}}: </span> {{ docuSignObj.created_on }}</p>
            </v-col>
            <v-col class="py-0" cols="6">
              <p><span class="font-weight-black">{{ $t('message.orders.createdBy') }}: </span> {{ docuSignObj.created_by.person || docuSignObj.created_by.organization }}</p>
            </v-col>
          </v-row>
          <p class="font-weight-black">{{$t('message.documents.signers')}}:</p>
          <v-simple-table dense class="bordered--table">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" width="25%">{{ $t('message.customer.name')}}</th>
                  <th class="text-left" width="25%">{{ $t('message.user.email') }}</th>
                  <th class="text-left" width="25%">{{ $t('message.documents.signatureType') }}</th>
                  <th class="text-left" width="25%">{{ $t('message.common.status') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in docuSignObj.invitations" :key="i">
                  <td>{{item.name}}</td>
                  <td>{{item.email}}</td>
                  <td>{{item.signature_type !== 'hand' ? $t('message.documents.strongAuthentication') : $t('message.documents.withoutStrongAuthentication')}}</td>
                  <td>{{item.status}}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
      <v-card v-else>
        <v-card-text>
          <v-form ref="documentForm">
            <v-row no-gutters>
              <v-col class="mb-1" cols="3">
                <v-text-field hide-details dense v-model.number="documentObj.name" :rules="$_requiredValidation" :label="$t('message.customer.name')" outlined></v-text-field>
              </v-col>
              <v-col cols="3" class="px-1">
                <v-menu v-model="documentObj.invitationValidTillMenu" :close-on-content-click="false" ransition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field  :value="$formatter.formatDate(documentObj.invitations_valid_until, 'YYYY-MM-DD' , 'DD.MM.YYYY')" outlined
                      :label="$t('message.documents.invitationValidTill')" dense hide-details readonly v-on="on"  prepend-icon="mdi-calendar"></v-text-field>
                  </template>
                  <v-date-picker v-model="documentObj.invitations_valid_until" @input="documentObj.invitationValidTillMenu = false" color="primary" first-day-of-week='1'></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="3" class="px-1">
                <v-menu v-model="documentObj.reminderDateMenu" :close-on-content-click="false" ransition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field  :value="$formatter.formatDate(documentObj.reminderdate, 'YYYY-MM-DD' , 'DD.MM.YYYY')" outlined
                      :label="$t('message.documents.reminderDate')" dense hide-details readonly v-on="on"  prepend-icon="mdi-calendar"></v-text-field>
                  </template>
                  <v-date-picker v-model="documentObj.reminderdate" @input="documentObj.reminderDateMenu = false" color="primary"
                    :min="reminderMinDate" first-day-of-week='1'></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="3" class="px-1">
                <v-select v-model="documentObj.language" :items="listOfLanguages" item-text="text" item-value="value" hide-details dense outlined></v-select>
              </v-col>
              <v-col class="px-1" cols="6">
                <v-textarea outlined dense hide-details v-model="documentObj.emailMessage" rows="3" :label="$t('message.documents.emailMessage')"></v-textarea>
              </v-col>
              <v-col class="px-1" cols="6">
                <v-row no-gutters>
                  <v-col cols="6">
                    <v-checkbox dense hide-details v-model="documentObj.emailDocumentsAfterSigning" :label="$t('message.documents.emailDocumentsAfterSigning')"></v-checkbox>
                  </v-col>
                  <v-col cols="6">
                    <v-checkbox dense hide-details v-model="documentObj.signeeShouldReadDocument" :label="$t('message.documents.signeeShouldReadDocument')"></v-checkbox>
                  </v-col>
                  <v-col cols="6">
                    <v-checkbox dense hide-details v-model="documentObj.signInSpecifiedOrder" :label="$t('message.documents.signInSpecifiedOrder')"></v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-divider class="mb-2"></v-divider>
              </v-col>
              <v-col class="mb-1" cols="12">
                <v-layout>
                  <v-flex xs3>
                    <p class="font-weight-black">{{ $t('message.documents.signers') }} :</p>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs3 class="d-flex">
                    <v-autocomplete outlined dense :items="getUsers" v-model="documentObj.user" :label="$t('message.orders.user')" :item-text="(item) => [item.firstname, item.lastname].join(' ')"
                      return-object hide-details></v-autocomplete>
                    <v-btn small color="primary" class="mt-2 ml-1" dark @click="addNewInvite()">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-col>
              <v-col class="mb-1" cols="12">
              </v-col>
              <v-col cols="12">
                <v-card outlined v-for="(invite, index) in invitations" :key="index" class="mb-1">
                  <v-card-text class="py-1">
                    <v-layout row>
                      <v-flex xs1>
                        <v-text-field :label="$t('message.common.order')" v-model="invite.order" hide-details dense outlined></v-text-field>
                      </v-flex>
                      <v-flex xs4 class="px-1">
                        <v-text-field :label="$t('message.user.email')" v-model="invite.email" hide-details dense outlined  :rules="invite.email ? $_emailValidation : $_requiredValidation"></v-text-field>
                      </v-flex>
                      <v-flex xs3>
                        <v-text-field :label="$t('message.customer.name')" v-model="invite.name" hide-details dense outlined></v-text-field>
                      </v-flex>
                      <v-flex xs3 class="pl-1">
                        <v-text-field :label="$t('message.customer.phone')" v-model="invite.sms" hide-details dense outlined placeholder="+473012345678" :rules="VismaMobileNumberValidation"></v-text-field>
                      </v-flex>
                      <v-flex xs1 class="d-flex justify-center">
                        <v-btn v-if="(index > 0) || (invitations.length > 1)" class="mt-2" small color="error" @click="removeInivite(index)" icon>
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-flex>
                      <v-flex xs5 class="mt-1">
                        <v-checkbox dense hide-details v-model="invite.allowSigningWithoutStrongAuthentication" :label="$t('message.documents.allowSigningWithoutStrongAuthentication')"></v-checkbox>
                      </v-flex>
                      <v-flex xs3 class="mt-1">
                        <v-checkbox dense hide-details v-model="invite.sign_as_organization" :label="$t('message.documents.signAsOrganization')"></v-checkbox>
                      </v-flex>
                      <v-flex xs4 class="mt-1">
                        <v-checkbox dense hide-details v-model="invite.notifyInviteesWhenEveryoneSigned" :label="$t('message.documents.notifyInviteesWhenEveryoneHasSigned')"></v-checkbox>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-center">
          <v-btn color="success" :loading="createDocuSignLoading" dark @click="createDocumentOnVisma()"> {{ $t('message.common.save') }} </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: ['sharepointDocument', 'getUsers'],
  data () {
    return {
      loading: true,
      docuSignObj: null,
      documentObj: {
      },
      reminderMinDate: moment().add(1, 'days').format('YYYY-MM-DD'),
      invitations: [],
      createDocuSignLoading: false
    }
  },
  computed: {
    listOfLanguages () {
      return [
        { text: 'Finnish', value: 'fi' },
        { text: 'Swedish', value: 'sv' },
        { text: 'English', value: 'en' },
        { text: 'Norwegian', value: 'nb' },
        { text: 'Danish', value: 'da' }
      ]
    },
    VismaMobileNumberValidation () {
      return [
        val => {
          if (!val) return true
          const regex = /^\+\d{2,14}$/
          return regex.test(val) || this.$t('message.common.invalidMobileno')
        }
      ]
    }
  },
  mounted () {
    this.getDocumentSignedInfo()
  },
  methods: {
    getDocumentSignedInfo () {
      this.loading = true
      const filePath = this.sharepointDocument.id
      this.$_executeApi('get', `vismasignconfiguration/get_file_signature_info?sharepointid=${filePath}`).then(({ data }) => {
        if (data) {
          this.docuSignObj = data
        } else {
          this.documentObj = {
            language: 'nb',
            name: this.sharepointDocument.name,
            invitations_valid_until: moment().add(30, 'days').format('YYYY-MM-DD')
          }
          this.addNewInvite()
        }
      }).finally(() => {
        this.loading = false
      })
    },
    addNewInvite () {
      const model = { order: this.invitations.length + 1 }
      if (this.documentObj.user) {
        const { firstname, email, phone } = this.documentObj.user
        model.name = [firstname].filter(x => x).join(' ')
        model.email = email || ''
        model.sms = (phone || '').replace(/\s/g, '') // to remove white spaces in phone
        if (model.sms) model.sms = `+47${model.sms}` // setting default country
        this.documentObj.user = null
      }
      this.invitations.push(model)
    },
    removeInivite (index) {
      this.invitations.splice(index, 1)
    },
    createDocumentOnVisma () {
      if (this.$refs.documentForm.validate()) {
        const document = this.$formatter.cloneVariable(this.documentObj)
        if (document.reminderdate) document.automatic_reminders = { method: 'all', dates: [document.reminderdate] }
        const invites = this.$formatter.cloneVariable(this.invitations)
        invites.sort((a, b) => a.order - b.order)
        invites.map((x, index) => {
          x.email = x.email.trim()
          x.signature_type = x.allowSigningWithoutStrongAuthentication ? 'hand' : 'strong'
          x.language = document.language
          x.document_read = document.signeeShouldReadDocument
          x.messages = {
            send_invitation_email: true,
            invitation_email_message: document.emailMessage || '',
            attachment_allowed: !!document.emailDocumentsAfterSigning,
            send_invitee_all_collected_email: !!x.notifyInviteesWhenEveryoneSigned
          }
          x.order = {
            index: index + 1,
            require_before_sending_next_invitations: !!document.signInSpecifiedOrder // If you want to sign the document in a specified order, this value must be true.
          }
        })
        const model = { document, invites }
        model.sharepointid = this.sharepointDocument.id
        this.createDocuSignLoading = true
        this.$_executeApi('post', 'vismasignconfiguration/create_visma_sign', model).then(({ data }) => {
          this.docuSignObj = data
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.savedSuccess') })
        }).finally(() => {
          this.createDocuSignLoading = false
        })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    }
  }
}
</script>
